(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("react-bootstrap"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "react-bootstrap"], factory);
	else if(typeof exports === 'object')
		exports["ReactBootstrapValidation"] = factory(require("react"), require("react-bootstrap"));
	else
		root["ReactBootstrapValidation"] = factory(root["React"], root["ReactBootstrap"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_67__, __WEBPACK_EXTERNAL_MODULE_70__) {
return 


/** WEBPACK FOOTER **
 ** webpack/universalModuleDefinition
 **/